function mainRender() {
  $(function () {
    $('#root').css('zoom', 'normal')
    let scale = document.body.clientWidth / 1080
    $('#root').css('zoom', scale)

    window.addEventListener(
      'resize',
      (function () {
        var timer
        return function () {
          if (timer) clearTimeout(timer)
          timer = setTimeout(function () {
            $('#root').css('zoom', 'normal')
            let scale = document.body.clientWidth / 1080
            $('#root').css('zoom', scale)
          }, 100)
        }
      })()
    )
    $('.str3').liMarquee({
      scrollamount: 100,
      loop: -1,
      circular: true,
      runshort: true,
    })
    // 轮播
    new Swiper('.mySwiper3', {
      loop: true,
      autoplay: {
        delay: 3000,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
      pagination: {
        el: '.swiper-pagination',
      },
    })
    new Swiper('#carousel .swiper', {
      loop: true,
      centeredSlides: true,
      spaceBetween: 24,
      slidesPerView: 2,
      freeMode: true,
      speed: 5000, //匀速时间
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
      },
    })
    //
    var swiper = new Swiper('.mySwiper', {
      direction: 'vertical',
      spaceBetween: 20,
      slidesPerView: 'auto',
      freeMode: true,
      watchSlidesProgress: true,
    })
    var imgArr = [
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-yellow2.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-red2.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-black2.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-white2.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-yellow3.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-red3.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-black3.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-white3.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-yellow5.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-red5.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-black5.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-white5.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-yellow1.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-red1.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-black1.jpg',
      'https://cdn.shopify.com/s/files/1/0877/7891/8712/files/20240816-white1.jpg',
    ]
    var swiper2 = new Swiper('.mySwiper2', {
      thumbs: {
        swiper: swiper,
      },
    })
    swiper.el.onclick = function (e) {
      // 切换到点击的slide
      var clickIndex = e.target.parentNode.getAttribute('data-index')
      $('.sp-pro-img>img').attr('src', imgArr[clickIndex])
      //
      choseActive(clickIndex)
    }
    // 初始化
    alignmentFns.initialize()
    // 数量
    let prods = window.product
    function getCur(){
      let color = $('.sp-size-wraper li.active').attr('data-val')
      let size = $('.sp-chose-wraper li.active').attr('data-val')
      return prods.filter(item=> item.option1 == color && item.option2 == size)[0]
    }
    function changePrice(){
      if(getCur() == undefined){ 
        $('.wagen-btn').addClass('sold_out')
        $('.sp-buynow').addClass('sold_out')
        $('.sp-buynow').css('animation', 'none')
      }else{
        $('.wagen-btn').removeClass('sold_out')
        $('.sp-buynow').removeClass('sold_out')
        $('.sp-buynow').css('animation', 'heartbit 0.5s alternate infinite')
      }
      let num = $('#2').val()
      let price = (getCur().price * num / 100).toFixed(2)
      let compare = (getCur().compare_at_price * num / 100).toFixed(2)
      // if(num == 1){
      //   price = (getCur().price * num / 100).toFixed(2)
      // }else if(num == 2){
      //   price = (getCur().price * num / 100 * 0.95).toFixed(2)
      // }else if(num == 3){
      //   price = (getCur().price * num / 100 * 0.9).toFixed(2)
      // }else {
      //   price = (getCur().price * num / 100 * 0.85).toFixed(2)
      // }
      // price = (price + '').replace('.', ',')
      // compare = (compare + '').replace('.', ',')
      $('#new').html(price)
      $('#old').html(compare)
      let off_font = 100 - Math.ceil(getCur().price / getCur().compare_at_price * 100)
      $(".sp-pro-offs span").html(off_font);
    }
    changePrice()
    $('.sp-buynow').click(function(){
      let num = $('#2').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    if (window.cartCount == 0) {
    $('.sp-buy-car span').css('background', '#999')
  } else {
    $('.sp-buy-car span').css('background', '#f24a00')
  }
  $('#addCart').click(function () {
      // do something here
      var data = {
        id: getCur().id,
        quantity: $('#2').val(),
      };
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: data,
        success: function () {
          $.getJSON(window.Shopify.routes.root + "cart.js", function (result) {
            $(".sp-buy-car span").html(result.item_count);
            if (result.item_count == 0) {
              $('.sp-buy-car span').css('background', '#999')
            } else {
              $('.sp-buy-car span').css('background', '#f24a00')
            }
          });
        },
        dataType: "json",
      });
      
      var img = $('.sp-pro-img img')
      var flyer = img[0].cloneNode(true)
      flyer.classList.add('clone')
      $('.sp-part5').append(flyer)
      $('.clone').css({
        width: '779px',
        height: '779px',
        position: 'fixed',
        top: img[0].offsetTop,
        left: img.offset().left,
        'z-index': '99',
      })
      var offset = $('.sp-buy-car')[0].getBoundingClientRect()
      $('.sp-buy-car').addClass('shake')
      setTimeout(() => {
        $('.sp-buy-car').removeClass('shake')
      }, 1000)
      let finish = $('.sp-buy-car')
      $('.clone').animate(
        {
          top: finish[0].offsetTop + 133,
          left: finish[0].offsetLeft + finish.width() / 2,
          width: 50, // 结束时的大小，根据需要调整
          height: 50, // 结束时的大小，根据需要调整
          opacity: 0.4,
        },
        1000,
        'linear',
        function () {
          $(this).animate(
            {
              width: 0,
              height: 0,
              opacity: 0,
            },
            0,
            function () {
              $(this).detach() // 完成动画后移除克隆的图片
            }
          )
        }
      )
    })
    $('#2').change(function () {
      changePrice()
    })
    // 颜色选择
    $('.sp-size-wraper li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      var index = $(this).index()
      var index2 = $('.sp-chose-wraper li.active').index()
      console.log(index + index2 * 4)
      swiper2.slideTo(index + index2 * 4)
      $('.sp-pro-img>img').attr('src', imgArr[index + index2 * 4])
      changePrice()
    })
    $('.sp-chose-wraper li').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      var index = $('.sp-size-wraper li.active').index()
      var index2 = $(this).index()
      swiper2.slideTo(index + index2 * 4)
      $('.sp-pro-img>img').attr('src', imgArr[index + index2 * 4])
      changePrice()
    })
    function choseActive(clickIndex) {
      var index = 0
      var index2 = 0
      var currentIndex = (clickIndex * 4) / 4
      if (currentIndex < 4) {
        index = (clickIndex * 4) / 4
        index2 = 0
      } else if (currentIndex < 8) {
        index = (clickIndex * 4) / 4 - 4
        index2 = 1
      } else if (currentIndex < 12) {
        index = (clickIndex * 4) / 4 - 8
        index2 = 2
      } else {
        index = (clickIndex * 4) / 4 - 12
        index2 = 3
      }
      $('.sp-size-wraper li')
        .eq(index)
        .addClass('active')
        .siblings()
        .removeClass('active')
      $('.sp-chose-wraper li')
        .eq(index2)
        .addClass('active')
        .siblings()
        .removeClass('active')
    }
    $(function () {
      // 倒计时的事件
      // 当前时间
      TimeDown(43200000)
      /*
       时间倒计时
       TimeDown.js
       */
      function TimeDown(value) {
        //倒计时的总秒数
        var totalSeconds = parseInt(value / 1000)
        //取模（余数）
        var modulo = totalSeconds % (60 * 60 * 24)
        //小时数
        var hours = Math.floor(modulo / (60 * 60))
        modulo = modulo % (60 * 60)
        //分钟
        var minutes = Math.floor(modulo / 60)
        //秒
        var seconds = modulo % 60

        hours = hours.toString().length == 1 ? '0' + hours : hours
        minutes = minutes.toString().length == 1 ? '0' + minutes : minutes
        seconds = seconds.toString().length == 1 ? '0' + seconds : seconds

        //输出到页面
        $('.hours').html(hours)
        $('.minutes').html(minutes)
        $('.seconds').html(seconds)
        //延迟一秒执行自己
        if (hours == '00' && minutes == '00' && parseInt(seconds) - 1 < 0) {
        } else {
          setTimeout(function () {
            TimeDown(value - 1000)
          }, 1000)
        }
      }
    })
  })

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll('.lazy-load') // 获取所有需要懒加载的图片
    const config = {
      rootMargin: '0px 0px 1300px 0px',
      threshold: 0,
    }

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target
          const dataSrc = image.getAttribute('data-src')
          image.src = dataSrc // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image) // 停止观察该图片
        }
      })
    },
    config)

    images.forEach(function (image) {
      lazyLoadObserver.observe(image) // 开始观察每个图片
    })
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image()
          img.src = url
        })
      })
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image()
        img.src = url
      })
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    lazyLoadImages()

    // preloadImages(imagesOneDim)
    // preloadImages(imagesTwoDim)

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]')
    links.forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault() // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById('shopping') // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop - 125
        window.scroll({
          top: offsetTop * $('div#root').css('zoom'),
          behavior: 'smooth', // 使用 smooth 实现平滑滚动
        }) // 方式二
      })
    })
  })

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera
  var isAndroid = /android/i.test(userAgent)
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent) // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log('Android')
  } else if (isIOS) {
    console.log('iOS')
  } else if (isPC) {
    console.log('PC')
  } else {
    $('.sp_system').css('letter-spacing', '-4px')
  }
}

mainRender()
